(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .service('LibElementTools', LibElementTools);

  LibElementTools.$inject = ['Constants'];

  function LibElementTools (Constants) {
    return {
      findModule: function (modules, element) {
        const module = modules.find((mod) => mod._id === element.moduleId);
        const submodule = module && module.submodules
          .find((submod) => submod._id === element.submoduleId);

        return {
          module: module,
          submodule: submodule
        };
      },

      getConstant: function (element, attribute, identifier) {
        const type = Constants.attributeToType(attribute);
        return Constants.fromList(type, element[attribute], identifier);
      }
    };
  }
})();
